import { useMemo } from 'react';
import getDocument from '../utils/getDocument';
const ROUTE_PREVIEW_ENABLED_COOKIE_NAME = 'hs_route_preview_enabled';
const APP_PREVIEW_COOKIE_NAME_REGEX = /hs_route_key_(.*?)_web/;
function hasAppPreviewCookieName(branchPreviewCookies) {
  const cookieKeys = Object.keys(branchPreviewCookies);
  return cookieKeys.some(key => APP_PREVIEW_COOKIE_NAME_REGEX.test(key));
}
function getCookies() {
  return getDocument().cookie.split(';').map(cookie => cookie.trim()).reduce((cookies, cookie) => {
    if (cookie) {
      const [name, value] = cookie.split('=').map(v => v.trim());
      cookies[name] = value;
    }
    return cookies;
  }, {});
}
export const useIsBranchPreviewEnabled = () => {
  const isBranchPreviewEnabled = useMemo(() => {
    const allCookies = getCookies();
    return Boolean(allCookies[ROUTE_PREVIEW_ENABLED_COOKIE_NAME]) && hasAppPreviewCookieName(allCookies);
  }, []);
  return isBranchPreviewEnabled;
};